<template>
  <center
    style="padding-left: 50px;padding-right:50px; padding-top:10px;padding-bottom:10px;"    
  >
    <v-btn
      block
      style="height: 50px;"
      :color="BGColorSecundary"
      :style="{ 'color': ColorSecundary}" 
      dark
      @click="handleGoTo"
    >
      {{ text }}
    </v-btn>
  </center>
  <!-- <v-alert
    :color="data.Color"
    dense
    text
    :icon="data.Icon"
    border="left"
    :style="{
      'margin': !isSimulation && isDesktop ? '15px 30px 15px 30px' : '15px' 
    }"
  >
    {{text}}
  </v-alert> -->
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import constants from '@/constants'
  import utils from '@/services/utils'
  export default {
    props: {
      data: {
        type: Object,
        required: true,
        default: null
      },
    },
    data: () => ({
    }),
    computed: {
      ...mapState('app',['BGColor', 'locale', 'FontContent', 'FontSizeContent', 'ColorContent', 'BGColorSecundary', 'ColorSecundary']),
      text () {
        return this.data.LinkDomainName ? utils.getTranslation (this.data.LinkDomainName, this.locale) : ''
      },
      isSimulation () {
        return constants.simulationsRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      isDesktop () {
        return !utils.isMobile()
      },
      isTotem () {
        return this.$route.path.indexOf('/totem') === 0 || utils.isTotem()
      },
      dtouchIsTouchPublic () {
         return this.$store.state.app.dtouchIsTouchPublic
      },
      path () {
        return this.$route.query.path && this.$route.query.path !== undefined ? this.$route.query.path : null
      },
    },
    methods: {
      handleGoTo () {
        if (this.isTotem)
          this.handleTotemChangeEnterprise (this.data.LinkDomain)
        else if (!this.isSimulation) {
          let url = `${window.location.protocol}//${this.data.LinkDomain}.${process.env.VUE_APP_API_URL}`
          url += '#/?back='+utils.getDomain()
          if (this.path) url += `&backPath=${this.path}`
          if (this.locale !== 'es' || this.dtouchIsTouchPublic) url += '&locale=' + this.locale
          if (this.dtouchIsTouchPublic) url += '&touchPublic=true&forceIMG=true'
          
          const dfileResp = this.$session.get('dfilesResponse')
          url= `${url}${dfileResp ? '&dfileResp='+dfileResp : ''}`
          
          // ini showroom
          const actualUrl = window.location.href
          if (actualUrl.indexOf('?') < 0) url += '?'
          if (actualUrl.indexOf('fm=true') > 0) url += '&fm=true'
          if (actualUrl.indexOf('fl=true') > 0) url += '&fl=true'
          // end showroom
          window.location.href = url
        }        
      },
      handleTotemChangeEnterprise (domain) {
        this.$store.state.app.totemBackDomain = this.$store.state.app.totemDomain
        this.$store.state.app.totemDomain = domain
      },
    },
  }
</script>
